<template>
  <div>
    <button
      type="button"
      class="b-pop-up__btn-social b-pop-up__btn-social--google"
      data-onsuccess="test"
      @click="onClickLogin">
      {{ buttonText }}
    </button>
  </div>
</template>
<script>
// https://medium.com/@toluarejibadey/how-to-use-google-login-in-vuejs-8c50cc2fa054
import { googleSdkLoaded } from 'vue3-google-login'
import postRequestHandler from './../../../lib/postRequestHandler'
import { updateUserDisplay } from './../../../lib/lib'
import constants from './../../../lib/constants'

export default {
  props: {
    buttonText: { default: 'Login with Google', type: String },
  },
  emits: [
    'loading',
    'closeModal',
    'showModalPendingRegistration',
    'showAlert',
    'hideAlert',
  ],
  data() {
    return {
      code: null,
      accessToken: null,
      idToken: null,
      userInfo: null,
    }
  },
  methods: {
    onClickLogin() {
      /* eslint-disable camelcase */
      const { clientId, scope, redirectUri } = this.configuration.google

      googleSdkLoaded((google) => {
        google.accounts.oauth2
          /* eslint-disable camelcase */
          .initCodeClient({
            client_id: clientId,
            scope: scope,
            redirect_uri: redirectUri,
            callback: (response) => {
              if (!response.code) {
                this.handleError()
                return false
              }

              this.code = response.code
              this.doGoogleLogin()
            },
          })
          .requestCode()
      })
    },

    async doGoogleLogin() {
      /* eslint-disable camelcase */
      const { clientId, redirectUri, endpointSubmitData } =
        this.configuration.google

      /* eslint-disable camelcase */
      const postData = {
        clientId: clientId,
        code: this.code,
        grantType: 'authorization_code',
        redirectUri: redirectUri,
      }
      postRequestHandler({
        postData,
        endpoint: endpointSubmitData,
        successCallback: this.handleSuccess,
        errorCallback: this.handleError,
        captchaAction: this.configuration.captchaAction,
        refreshTokenHandler: this.configuration.refresh,
      })
    },

    handleError() {
      this.$emit('loading', false)
      this.$emit('showAlert', [this.dictionary.defaultErrorMessage])
    },

    handleSuccess(data) {
      this.$emit('loading', false)
      this.$emit('closeModal', true)
      this.$emit('hideAlert')

      const { loggedIn, pendingRegistration } = constants.socialLogin.status
      const { status, redirectUrl } = data.data

      switch (status.toLowerCase()) {
        case loggedIn:
          this.handleSuccessLoggedIn(data)
          break
        case pendingRegistration:
          this.handleSuccessPendingRegistration()
          break
        default:
          console.log(`Sorry, we are out of ${status}.`)
      }

      if (redirectUrl) {
        window.location.assign(redirectUrl)
      }
    },

    handleSuccessLoggedIn(data) {
      const { accountData } = data.data

      if (accountData) {
        const { firstName, fullName, lastName, avatar } = accountData
        updateUserDisplay({ img: avatar?.url, firstName, fullName, lastName })

        document.dispatchEvent(
          new CustomEvent('login-was-held', {
            detail: { accountData },
          }),
        )

        window.location.reload()
      }
    },

    handleSuccessPendingRegistration() {
      this.$emit('showModalPendingRegistration', false)
    },
  },
}
</script>
